export default {
  lookup: {
    column_createdon: '创建时间',
    column_name: '名称'
  },
  xpc: {
    address: {
      city: '市',
      county: '县/区',
      noSelected: '未选择',
      province: '省',
      parse: '识别',
      errorMsg: '识别失败，请填写正确的格式',
      successMsg: '识别成功'
    },

    addressCascader: {
      city: '市',
      country: '县',
      province: '省'
    },
    advancetable: {
      checkall: '全选'
    },
    attachment: {
      novalue: '暂时没有附件哦',
      successmsg: '附件上传成功！',
      title: '附件'
    },
    business: {
      attr: {
        detail: '详情'
      },
      detailaside: {
        more: '展开更多',
        up: '收起全部'
      }
    },
    common: {
      add: '添加',
      cancel: '取消',
      collapse: '收起',
      comfirmDelete: '确定需要删除这条内容吗？',
      comfirmLogout: '确认注销？',
      confirmDeleteAll: '确定需要全部删除吗？',
      delete: '删除',
      edit: '编辑',
      hasEnter: '已输入 {count} 字',
      hint: '提示',
      loadError: '加载失败',
      look: '查看',
      main: '主要',
      messageNotification: '消息通知',
      more: '更多',
      next: '下一条',
      noSelected: '未选择',
      ok: '确定',
      operation: '操作',
      pleaseSearch: '请搜索',
      pleaseSelect: '请选择',
      prev: '上一条',
      reset: '重置',
      saving: '正在保存',
      seemore: '查看更多',
      selected: '已选',
      showAll: '查看全部',
      totalRecords: '共 {count} 条记录',
      record: '记录',
      notFound: '未找到{label}'
    },
    datepicker: {
      endDateCannotEarlierStartDate: '结束日期不能早于开始日期！',
      pleaseSelectStartDate: '请先选择开始日期！',
      to: '至'
    },
    defaultImage: {
      noData: '暂无数据'
    },
    detailheader: {
      back: '返回'
    },
    comment: {
      reply: '回复',
      comment: '评论 ',
      report: '举报 ',
      expression: '表情 ',
      publish: '发表',
      author: '作者',
      entercommentshere: '在此输入评论内容...',
      smile: '微笑',
      heehee: '嘻嘻',
      haha: '哈哈',
      lovely: '可爱',
      poor: '可怜',
      nosedigging: '挖鼻',
      beamazed: '吃惊',
      shyness: '害羞',
      blinkeyes: '挤眼',
      shutup: '闭嘴',
      despise: '鄙视',
      loveyou: '爱你',
      tear: '泪',
      snicker: '偷笑',
      kiss: '亲亲',
      fallill: '生病',
      toohappy: '太开心',
      superciliouslook: '白眼',
      righthem: '右哼哼',
      lefthem: '左哼哼',
      shh: '嘘',
      decline: '衰',
      spit: '吐',
      yawn: '哈欠',
      cuddle: '抱抱',
      anger: '怒',
      doubt: '疑问',
      greedy: '馋嘴',
      byebye: '拜拜',
      reflection: '思考',
      sweat: '汗',
      sleepy: '困',
      sleep: '睡',
      money: '钱',
      disappointment: '失望',
      cool: '酷',
      colour: '色',
      hum: '哼',
      applause: '鼓掌',
      halo: '晕',
      sadness: '悲伤',
      madness: '抓狂',
      blackline: '黑线',
      insidious: '阴险',
      fulminate: '怒骂',
      becomeother: '互粉',
      bookworm: '书呆子',
      cold: '感冒',
      heart: '心',
      sad: '伤心',
      pig: '猪',
      panda: '熊猫',
      rabbit: '兔子',
      wok: '喔克',
      yeah: '耶',
      bangbang: '棒棒',
      no: '不',
      fabulous: '赞',
      come: '来',
      weak: '弱',
      grassmudhorse: '草泥马',
      divinehorse: '神马',
      embarrassed: '囧',
      floatingclouds: '浮云',
      awesome: '给力',
      gatherandwatch: '围观',
      mighty: '威武',
      microphone: '话筒',
      candle: '蜡烛',
      cake: '蛋糕',
      redenvelopes: '发红包'
    },
    dialog: {
      cancel: '取消',
      confirm: '确认',
      oneClickClear: '一键清空',
      exitFullScreen: '退出全屏',
      fullScreen: '全屏',
      exitBrowserFullScreen: '退出网页全屏',
      browserFullScreen: '网页全屏',
      collapse: '收起',
      expandDown: '向下展开',
      expandLeft: '向左展开',
      expandUp: '向上展开',
      expandRight: '向右展开'

    },
    form: {
      notFilled: '未填写',
      pleaseEnter: '请输入',
      addFormItem: '新增表单项'
    },
    lookup: {
      placeholder: '请选择',
      selectedItems: '已选择 {count} 项',
      searchItems: '已选择 {count} 项，为你搜到 {search} 项',
      showSelected: '仅显示已选项'
    },
    search: {
      more: '更多筛选',
      search: '搜索',
      pleaseSearch: '请搜索...'
    },
    section: {
      more: '更多'
    },
    uploadfile: {
      confirmdelete: '确定需要删除这条内容吗？',
      delete: '删除',
      download: '下载',
      edit: '编辑',
      filelist: '文件列表',
      filename: '文件名称',
      filenameplaceholder: '请填写文件名称',
      filesize: '文件大小',
      nodata: '暂无数据',
      operate: '操作',
      pleaseAddCorrectVideoFormat: '请上传正确的视频格式',
      pleaseAddFileHint: '请将需要上传的文件添加到此处',
      reUpload: '重新上传',
      remark: '备注',
      remarkplaceholder: '请填写备注',
      save: '保存',
      size: '大小：',
      title: '标题',
      titleplaceholder: '请填写标题名称',
      updownError: '上传失败',
      upload: '点击上传',
      uploadError: '上传错误',
      uploadPercent: '已上传{count}%',
      uploadSuccess: '上传成功',
      uploaded: '已上传{count}',
      uploadfile: '上传文件',
      uploading: '正在上传...',
      videoSizeCannotExceed5000: '视频大小不能超过5000MB',
      notAdded: '暂未添加'
    },
    richEditor: {
      placeholder: '请输入内容',
      undo: '撤销',
      redo: '重做',
      h1: '标题1',
      h2: '标题2',
      h3: '标题3',
      h4: '标题4',
      text: '正文',
      italic: '斜体',
      underline: '下划线',
      strike: '删除线',
      sub: '上标',
      super: '下标',
      clean: '清除样式',
      ordered: '有序列表',
      bullet: '无序列表',
      indent0: '减少缩进',
      indent1: '增加缩进',
      blockquote: '引用',
      link: '链接',
      image: '图片',
      video: '视频',
      divider: '分隔线'
    },
    guide: {
      startExpericencing: '开始体验'
    },
    table: {
      selectedItemsPrev: '已选',
      selectedItemsNext: '项',
      deleteAllSelected: '确定移除所有选中项？',
      confirmationPrompt: '确认提示'
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/locale/lang/zh-CN.js